
import {
	Component,
	Vue
} from 'vue-property-decorator';
import RadioButton from '@/components/radio-button.vue';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import qrCode from '@/components/qrCode.vue';
import {
	productList,
	delProduct,
	productCategory,
	productInfo,
	createProduct,
	productOpen,
	producttimedUpAndDown,
	productsetSalesCoefficient,
	productproductStockWarning,
	productsaveProductAfterSaleConfig,
	producteidtIsShowPoster,
	productsendProductUpMessage,
	productproductOpeningTimeEdit,
	productOpenTimeLabelFilterList
} from '@/api/supplier';
import {
	handleClipboard
} from '@/utils/clipboard';
import {
	parseTime,
	getToday,
	getYestarDay,
	getBeforeYestarDay,
	getInSevenDay
} from '@/utils/index';
import Message from '@/components/message.vue';

import { imgHost } from '@/utils/config'
import {
	UserModule
} from "@/store/modules/user"

import {
	providerReturnAddressSelectItem,
} from '@/api/logistics'

import {
	currentEmployeeRoleInfo
} from '@/api/order'

import SelectRefundAddress from './components/select-refund-address.vue';

import {
	productfilterBoxList,
	productpopoverproductlist
} from '@/api/material'
import Switch from '@/components/switch.vue';
import {
	nextDay,
	getSearchDate
} from "@/utils"

@Component({
	name: 'product-list',
	components: {
		RadioButton,
		PageFooter,
		Message,
		PickerDate,
		'slz-dialog': Dialog,
		qrCode,
		SelectRefundAddress,
		'slz-switch': Switch,
	}
})
export default class ProductList extends Vue {
	private imgUrl = imgHost;
	private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
	private supplierNameKey = '';
	private productIDKey = '';
	private list: any[] = [];
	private radioType = 0;
	private showDialog = false;
	private radioList: any = [{
		label: '全部',
		value: 0
	}, {
		label: '上架中',
		value: 1
	}, {
		label: '已下架',
		value: 2
	},
	];

	private selectTime = 0;
	private timeScope: any = [{
		label: '今日',
		value: 1
	}, {
		label: '昨日',
		value: 2
	}, {
		label: '前天',
		value: 3
	}, {
		label: '近7日',
		value: 4
	}
	]

	private categoryList: any = [];
	private categoryId = '';
	private filterTime: any = '';

	private openTimeLabel = '';
	private openTimeLabelList: any = [];

	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private currentDelId = 0;
	private currentCopyId = 0;
	private showCopyDialog = false
	private schedulingShow = false
	private schedulingLoading = false
	private schedulingmsg: any = {
		ProductId: 0,
		IsOpen: false,
		Time: ''
	}
	private pickerOptions: any = {
		disabledDate: (v => {
			return v.getTime() <= new Date().getTime() - 1000 * 60 * 60 * 24
		})
	}
	private coefficientShow = false
	private coefficientmsg: any = {
		ProductId: 0,
		VirtualSales: 0,
		SalesCoefficientMin: 0,
		SalesCoefficientMax: 0
	}
	private rowmsg: any = {}
	private coefficientloading = false
	private showcode = false
	private codemsg: any = {}

	private earlywarningShow = false



	private warnlist: any = []

	private aftersalesShow = false
	private aftersalesmsg: any = {
		ProductId: 0,
		IsOpenChangeProduct: true,
		IsOpenRefundProduct: true,
		IsOpenOnlyRefundMoney: true,
		ProviderReturnAddressId: ''
	}
	private refundList: any = []
	private refundProviderId = ''
	private showSelectRefundAddress = false
	private selectRA: any = {}

	private informShow = false
	private relevance: any = {
		Id: '',
		ProductName: ''
	}
	private shelf: any = {
		list: [],
		remark: '爆品复团，只有3天，点击下单！',
		time: getSearchDate(2, false, 0)[0]
	}
	private shoplist: any = []
	private shopindex = 1
	private lastkeywords = ''
	private chooselist: any = []
	private changeTimeShow = false
	private startclique = ''
	private endclique = ''
	private errorlistShow = false
	private errlist: any = []
	private changeloading = false

	private permissions = true;

	private async activated() {
		// var dt = new Date();
		// var year = dt.getFullYear();
		// var month = dt.getMonth()+1;
		// var day = dt.getDate();
		// this.filterTime = [year, month, day].join('-')+'/'
		await this.getOpenTimeLabel();
		this.getProductList();
		this.getProductCategory();
		this.getRole();
		this.getwarn()
	}
	private mounted() {
		// console.log(this.userId)
		var dt = new Date();
		var year = dt.getFullYear();
		var month = dt.getMonth() + 1;
		var day = dt.getDate();
		this.filterTime = [year, month, day].join('-') + '/'

		// this.getProductList();
		// this.getProductCategory();
	}




	get userId() {
		return Number(UserModule.mallInfo.EmployeeId)
	}
	private get showRuleButton() {
		return UserModule.mallInfo.IsHaveFreightSettlementTemplateLimit
	}

	private async getRole() {
		let res: any = await currentEmployeeRoleInfo({})
		if (res.IsSuccess) {
			this.permissions = res.Result.ProductLibraryIsPartPermissions;
		}
	}

	private toSetSupplyPrice(row) {
		this.$router.push({
			path: 'setSupplyPrice',
			query: {
				Id: row.Id,
				// ProviderId:row.ProviderId,
				Name: encodeURIComponent(row.ProductName),
				Img: encodeURIComponent(row.ImgUrlComplete || this.defaultThumb),
			}
		})
	}
	private async savetime() {
		// if(!this.startclique&&!this.endclique){
		// 	this.$message.error('请设置时间')
		// 	return
		// }
		if (this.startclique && this.endclique && new Date(this.startclique).getTime() > new Date(this.endclique).getTime()) {
			this.$message.error('结束时间不得早于开始时间')
			return
		}
		let list = this.errlist
		try {
			this.changeloading = true
			for (let item of this.chooselist) {
				let res = await productproductOpeningTimeEdit({
					ProductId: item.Id,
					OpenTime: this.startclique,
					TakedownTime: this.endclique,
					noError: true
				})
				if (!res.IsSuccess) {
					list.push({
						...item,
						Error: res.Message
					})
				}
			}
		} finally {
			if (!list || !list.length) {
				this.$message.success('操作成功')
				this.$nextTick(() => {
					(this.$refs.table as any).clearSelection()
				})
			} else {
				this.errlist = list
				this.errorlistShow = true
			}
			this.closetime()
			this.changeloading = false
			this.getProductList()
		}
	}
	private closetime() {
		this.startclique = ''
		this.endclique = ''
		this.changeTimeShow = false
	}
	private batchChange() {
		if (!this.chooselist || !this.chooselist.length) {
			this.$message.error('请选择商品')
			return
		}
		this.changeTimeShow = true
	}
	private selectionChange(list) {
		this.chooselist = list
	}
	private selectable(row) {
		// return row.IsOpen||row.VirtualSales>0
		return row.OpenTime
	}
	private toSettleFreight(row) {
		this.$router.push({
			path: 'settleFreight',
			query: {
				Id: row.Id,
				// ProviderId:row.ProviderId,
				Name: encodeURIComponent(row.ProductName),
				Img: encodeURIComponent(row.ImgUrlComplete || this.defaultThumb),
			}
		})
	}
	private async confirmsend() {
		// console.log(this.rowmsg)
		// return
		if (!this.shelf.list || !this.shelf.list.length) {
			this.$message.error('请选择关联的商品')
			return
		} else if (!this.shelf.remark) {
			this.$message.error('请输入备注文案')
			return
		} else if (!this.shelf.time) {
			this.$message.error('请输入上架时间')
			return
		}
		try {
			let res: any = await productsendProductUpMessage({
				ProductId: this.rowmsg.Id,
				RelationProductId: this.shelf.list.map(v => v.Id),
				Remark: this.shelf.remark,
				UpTime: this.shelf.time,
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.informShow = false
				this.getProductList()
			}
		} finally {
			//
		}
	}
	private touchbottom() {
		this.shopindex++
		this.geteasyProductList(this.lastkeywords)
	}
	private async geteasyProductList(keywords?: string) {
		if ((keywords && keywords != this.lastkeywords) || (this.lastkeywords && !keywords)) {
			this.shopindex = 1
			this.shoplist = []
			this.lastkeywords = keywords
		}
		const params: any = {
			Skip: (this.shopindex - 1) * 20,
			Take: 20,
			Keywords: keywords
		}
		try {
			const res: any = await productpopoverproductlist(params)
			if (res.IsSuccess) {
				this.shoplist = [...this.shoplist, ...res.Result.Results];
			}
		} finally {
			//
		}
	}
	private closetag(i) {
		this.shelf.list.splice(i, 1)
	}
	private pushshop() {
		if (!this.relevance.Id) {
			this.$message.error('请选择关联的商品')
			return
		}
		if (this.shelf.list.some(v => v.Id == this.relevance.Id)) {
			this.$message.error('请勿重复添加关联的商品')
			return
		}
		let shop = this.shoplist.find(v => v.Id == this.relevance.Id)
		if (shop && shop.Id) {
			this.relevance = shop
			this.shelf.list.push(shop)
			this.relevance = {
				Id: '',
				ProductName: ''
			}
		}
	}
	private getinform(row) {
		this.informShow = true
		this.rowmsg = row
		this.relevance = {
			Id: '',
			ProductName: ''
		}
		this.shelf = {
			list: [],
			remark: '爆品复团，只有3天，点击下单！',
			time: getSearchDate(2, false, 0)[0]
		}
		this.geteasyProductList()
	}
	private async changeswitch(e, row) {
		try {
			let res: any = await producteidtIsShowPoster({
				ProdutId: row.Id,
				IsShowPoster: e
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.getProductList()
			}
		} finally {
			//
		}
	}
	private selectRefundAddress(row) {
		this.aftersalesmsg.ProviderReturnAddressId = row.Id;
		this.selectRA = row
		this.showSelectRefundAddress = false
	}
	private showSelectRefund() {
		this.showSelectRefundAddress = true
	}

	private async Confirmsaveaftersales() {
		try {
			let res = await productsaveProductAfterSaleConfig(this.aftersalesmsg)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.aftersalesShow = false
				this.getProductList()
			}
		} finally {
			//
		}
	}
	private async getwarn() {
		try {
			let res = await productproductStockWarning({
				Skip: 0,
				Take: 999999,
			})
			if (res.IsSuccess) {
				this.warnlist = res.Result.Results
				if (this.warnlist && this.warnlist.length && UserModule.earlywarningShow) {
					this.earlywarningShow = true
				}
			}
		} finally {
			//
		}
	}
	private async Confirmscoefficient() {
		if (this.coefficientmsg.VirtualSales && (this.coefficientmsg.VirtualSales < 0 || this.coefficientmsg.VirtualSales > 10000)) {
			this.$message.error('销量单次增加的数值请不要超过一万')
			return
		} else if (this.coefficientmsg.SalesCoefficientMin < 0 ||
			this.coefficientmsg.SalesCoefficientMin != parseInt(this.coefficientmsg.SalesCoefficientMin) ||
			this.coefficientmsg.SalesCoefficientMax < 0 ||
			this.coefficientmsg.SalesCoefficientMax != parseInt(this.coefficientmsg.SalesCoefficientMax) ||
			this.coefficientmsg.SalesCoefficientMax < this.coefficientmsg.SalesCoefficientMin) {
			this.$message.error('请输入正确的系数区间')
			return
		}
		try {
			this.coefficientloading = true
			let res = await productsetSalesCoefficient(this.coefficientmsg)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.cancelcoefficient()
				this.getProductList()
			}
		} finally {
			this.coefficientloading = false
		}
	}
	private cancelcoefficient() {
		this.coefficientmsg = {
			ProductId: 0,
			VirtualSales: 0,
			SalesCoefficientMin: 0,
			SalesCoefficientMax: 0
		}
		this.coefficientShow = false
	}
	private async Confirmscheduling() {
		if (!this.schedulingmsg.Time) {
			this.$message.error(`请设置${this.schedulingmsg.IsOpen ? '上架' : '下架'}时间`)
			return
		} else if (new Date(this.schedulingmsg.Time).getTime() <= new Date().getTime()) {
			this.$message.error(`请选择当前之后的时间`)
			return
		}
		try {
			this.schedulingLoading = true
			let res = await producttimedUpAndDown(this.schedulingmsg)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.cancelscheduling()
				this.getProductList()
			}
		} finally {
			this.schedulingLoading = false
		}
	}
	private cancelscheduling() {
		this.schedulingShow = false
		this.schedulingmsg = {
			ProductId: 0,
			IsOpen: false,
			Time: ''
		}
	}

	private emptyTime() {
		this.filterTime = ''
		this.selectTime = 0
	}

	private handleChange(e) {
		this.pageNo = 1;
		this.getProductList();
	}

	private toCreate() {
		this.$router.push({
			name: 'Product_Detail',
			query: {
				type: 'new'
			}
		})
	}

	private handleTimeScopeChange(e) {
		if (e === 1) {
			this.filterTime = getToday();
		}
		if (e === 2) {
			this.filterTime = getYestarDay();
		}
		if (e === 3) {
			this.filterTime = getBeforeYestarDay();
		}
		if (e === 4) {
			this.filterTime = getInSevenDay();
		}

		this.doSearch();
	}

	/**
	 * 获取商品分类
	 */
	private async getProductCategory() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 999999,
			});
			this.categoryList = res.Result.Results.map(item => {
				return {
					value: item.Id,
					label: item.CategoryName
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	/**
	 * 获取开团日期标签
	 */
	private async getOpenTimeLabel() {
		try {
			const res: any = await productOpenTimeLabelFilterList({
				Skip: 0,
				Take: 999999,
			});
			this.openTimeLabelList = res.Result.map((item, i) => {
				return {
					value: i,
					label: item.OpenTimeLabel
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	/**
	 * 搜索
	 */
	private doSearch() {
		this.pageNo = 1;
		this.getProductList();
	}

	/**
	 * 清空搜索内容
	 */
	private clearSearch() {
		this.productIDKey = '';
		this.supplierNameKey = '';
		this.categoryId = '';
		this.filterTime = '';
		// this.radioType = 0;
		this.pageNo = 1;
		this.selectTime = 0
		this.openTimeLabel = ''
		this.getProductList();
	}

	/**
	 * 跳转到排行榜
	 */
	private toRank(row) {
		this.$router.push({
			name: 'Product_Rank',
			query: {
				id: row.Id + '',
				ImgUrlComplete: row.ImgUrlComplete,
				ProductName: row.ProductName,
				ProductType: row.ProductType
			}
		})
	}

	/**
	 * 跳转到详情
	 */
	private toDetail(id: number, type) {
		this.earlywarningShow = false
		this.$router.push({
			name: 'Product_Detail',
			query: {
				type: 'edit',
				isLook: type ? '1' : '',
				id: id + ''
			}
		})
	}

	/**
	 * 分页器改变返回
	 */
	private changeCurrent(val: number) {
		this.pageNo = val;
		this.getProductList();
	}

	handleExport() {
		let params: any = {
			Keywords: this.productIDKey.trim(),
			ProviderName: this.supplierNameKey.trim(),
			ProductCategoryId: this.categoryId || '',
		}

		if (this.radioType === 0) {
			params.IsOpen = '';
		}
		if (this.radioType === 1) {
			params.IsOpen = true;
		}
		if (this.radioType === 2) {
			params.IsOpen = false;
		}
		if (this.radioType === 3) {
			params.IsWaitSchedule = true;
			params.IsOpen = ''
		}

		if (this.filterTime && this.radioType != 3) {
			var splitList = this.filterTime.split('/');
			params.StartTime = splitList[0];
			params.EndTime = splitList[1] ? (nextDay(splitList[1], 1)) : '';
		}

		if (this.openTimeLabelList[this.openTimeLabel]?.label) {
			params.OpenTimeLabel = this.openTimeLabelList[this.openTimeLabel]?.label;
		}

		const urls = Object.entries(params).map(item => {
			return `${item[0]}=${item[1]}`;
		})

		const url = `${window.origin}/pc/product/productList?${urls.join('&')}`;
		window.open(url);

	}

	/**
	 * 商品列表
	 */
	private async getProductList() {
		try {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				Keywords: this.productIDKey.trim(),
				ProviderName: this.supplierNameKey.trim(),
				ProductCategoryId: this.categoryId,
				OpenTimeLabel: this.openTimeLabelList[this.openTimeLabel]?.label
			}

			if (this.radioType === 0) {
				params.IsOpen = null;
			}
			if (this.radioType === 1) {
				params.IsOpen = true;
			}
			if (this.radioType === 2) {
				params.IsOpen = false;
			}
			if (this.radioType === 3) {
				params.IsWaitSchedule = true;
				params.IsOpen = null
			}

			if (this.filterTime && this.radioType != 3) {
				var splitList = this.filterTime.split('/');
				params.StartTime = splitList[0];
				params.EndTime = splitList[1] ? (nextDay(splitList[1], 1)) : '';
			}

			const res: any = await productList(params);
			this.total = res.Result.Total;
			this.list = res.Result.Results;
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	// 复制操作
	private doCopy(event: any, data: any) {
		let text = ''
		text += ('ID: ' + data.Id + '\n')
		text += ('商品名称: ' + data.ProductName + '\n')
		text += ('供应商: ' + data.ProviderName + '\n')
		text += ('原价: ' + data.ProductPrice + '\n')
		text += ('团购价: ' + data.GroupPrice + '\n')
		text += ('库存: ' + data.Stock + '\n')
		text += ('上架排期: ' + data.OpenTime + '\n')
		text += ('状态: ' + (data.IsOpen ? '已上架' : '未上架') + '\n')
		text += ('分成: ' + (!data.IsHaveOrderFee ? '是' : '否') + '\n')
		handleClipboard(text, event)
	}

	// 复制商品
	private confirmCopy(id: number) {

		this.currentCopyId = id
		this.showCopyDialog = true
	}

	// 确认复制
	private handleCopy() {
		this.$router.push({
			name: 'Product_Detail',
			query: {
				type: 'copy',
				id: this.currentCopyId + ''
			}
		})
		// try {
		// 	const res: any = await productInfo({
		// 		Id: this.currentCopyId
		// 	})

		// 	var obj:any = res.Result;
		// 	obj.Id = 0;
		// 	await createProduct({
		// 		ProductInfo: obj
		// 	})

		// 	this.$message({
		// 		type: 'success',
		// 		message: '复制成功'
		// 	})
		// 	this.showCopyDialog = false;
		// 	this.pageNo = 1;
		// 	this.list = [];
		// 	this.getProductList();
		// } catch (err) {
		// 	console.log(err)
		// }
	}

	// 删除弹窗
	private handleDel(id: number) {
		this.showDialog = true;
		this.currentDelId = +id;
	}

	// 确认删除
	private async confirmDelete() {
		try {
			await delProduct({
				product_id: this.currentDelId
			})
			this.$message({
				type: 'success',
				message: '删除成功'
			})
			this.showDialog = false;
			this.getProductList();
		} catch (e) {
			this.showDialog = false;
			console.log(e)
		}
	}

	//上下架
	private async handleOpen(e, row) {
		// console.log(e,row)
		if (e.type == 1) {
			this.upanddown(row.Id, e.bol)
		} else {
			this.schedulingShow = true
			this.schedulingmsg = {
				ProductId: row.Id,
				IsOpen: !row.IsOpen,
				Time: (row.IsOpen ? row.AutoAddedTime : row.AutoTakedownTime) || ''
			}
		}
	}

	private async upanddown(id, bol) {
		try {
			await productOpen({
				ProductId: id,
				IsOpen: bol
			})
			this.$message({
				type: 'success',
				message: '操作成功'
			})
			this.getProductList();
		} catch (e) {
			console.log(e)
		}
	}

	//更多
	handleCommand(command, record: any) {
		this.rowmsg = record
		if (command == 1) {
			this.toRank(record)
		} else if (command == 2) {
			this.$router.push({
				name: "product-material",
				query: {
					id: record.Id,
					img: record.ImgUrl && record.ImgUrl.length ? record.ImgUrl[0] : '',
					name: record.ProductName
				}
			})
		} else if (command == 3) {
			// console.log(record)
			this.coefficientmsg = {
				ProductId: record.Id,
				VirtualSales: '',
				SalesCoefficientMin: record.SalesCoefficientMin,
				SalesCoefficientMax: record.SalesCoefficientMax
			}
			this.coefficientShow = true
		} else if (command == 4) {
			// console.log(record)
			this.codemsg = {
				type: 1,
				Id: record.Id,
				title: record.ProductName
			}
			this.showcode = true
		} else if (command == 5) {
			this.aftersalesShow = true
			this.selectRA = {}
			this.getproductInfo(record)
		}
	}

	private async getproductInfo(record) {
		try {
			const res: any = await productInfo({
				Id: await record.Id
			})
			if (res.IsSuccess) {
				// console.log(res)
				for (let key in this.aftersalesmsg) {
					this.aftersalesmsg[key] = res.Result[key]
					this.aftersalesmsg.ProductId = res.Result.Id
				}
				this.refundProviderId = res.Result.ProviderId
				let res2 = await providerReturnAddressSelectItem({
					ProviderId: this.refundProviderId
				})
				this.selectRA = res2.Result.find(v => v.Id == this.aftersalesmsg.ProviderReturnAddressId) || {}
				// console.log(this.aftersalesmsg)
			}
		} finally {
			//
		}
	}

	private toActivityConfig(name: string, id: number) {
		this.$router.push({
			name: "Activity_Detail",
			query: {
				id: id + '',
				name: name
			}
		})
	}
}
